import ApplicationAdapter from 'cio/adapters/application';
import { ModelRegistry } from 'ember-data/model';
import DS from 'ember-data';

export default class ObjectAdapter extends ApplicationAdapter {
  // Build URLs in the format: /v1/environments/:id/object_types/:type_id/objects/:identifier
  buildURL(
    modelName?: keyof ModelRegistry,
    id?: string,
    snapshot?: DS.Snapshot | any[] | null,
    requestType?: string,
    query?: Record<string, number | string>,
  ): string {
    let objectTypeId: string | number | null =
      (snapshot as any)?.record.belongsTo('objectType').id() ?? (snapshot as any)?.adapterOptions?.objectTypeId ?? null;

    if (objectTypeId === null && query?.objectTypeId != null) {
      objectTypeId = query.objectTypeId;
    }

    if (objectTypeId == null) {
      throw new Error(
        'objectTypeId must be defined before making a request to fetch a list for an object or object type',
      );
    }

    if (this.environment.current.id == null) {
      throw new Error('environment needs to be initialized before making a request to fetch an object');
    }

    if (id != null) {
      return `${this.host}/${this.namespace}/environments/${this.environment.current.id}/object_types/${objectTypeId}/objects/${id}`;
    }

    return `${this.host}/${this.namespace}/environments/${this.environment.current.id}/object_types/${objectTypeId}/objects`;
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your adapters.
declare module 'ember-data/types/registries/adapter' {
  export default interface AdapterRegistry {
    object: ObjectAdapter;
  }
}
